import React from 'react';
import { QuoteData } from '../../types';
import { formatCurrency, formatPercent } from '../../lib/calculations';
import { motion } from 'framer-motion';
import { Clock } from 'lucide-react';
interface LoanDetailsProps {
  data: QuoteData;
}
export function LoanDetails({
  data
}: LoanDetailsProps) {
  return <motion.div initial={{
    opacity: 0
  }} animate={{
    opacity: 1
  }} transition={{
    delay: 0.8,
    duration: 0.8,
    ease: 'easeOut'
  }} className="bg-charcoal-800 rounded-2xl border border-white/10 border-l-[3px] border-l-gold p-6 md:p-8" data-id="element-88">
      <div className="text-[10px] font-medium tracking-[0.2em] text-gold mb-8 flex items-center gap-3" data-id="element-89">
        <span className="text-gold/50" data-id="element-90">—</span> YOUR LOAN
      </div>

      <div className="space-y-2 mb-10" data-id="element-91">
        <div className="flex justify-between items-center py-3 border-b border-white/5 text-sm" data-id="element-92">
          <span className="text-gray-500 font-light" data-id="element-93">Loan Type</span>
          <span className="text-white" data-id="element-94">{data.loanType}</span>
        </div>
        <div className="flex justify-between items-center py-3 border-b border-white/5 text-sm" data-id="element-95">
          <span className="text-gray-500 font-light" data-id="element-96">Lender</span>
          <div className="text-right" data-id="element-97">
            <div className="text-white" data-id="element-98">{data.lenderName}</div>
          </div>
        </div>
        <div className="flex justify-between items-center py-3 border-b border-white/5 text-sm" data-id="element-99">
          <span className="text-gray-500 font-light" data-id="element-100">Rate</span>
          <span className="text-gold" data-id="element-101">{formatPercent(data.proposedRate)}</span>
        </div>
        <div className="flex justify-between items-center py-3 border-b border-white/5 text-sm" data-id="element-102">
          <span className="text-gray-500 font-light" data-id="element-103">Loan Amount</span>
          <span className="text-white" data-id="element-104">
            {formatCurrency(data.proposedLoanAmount)}
          </span>
        </div>
        <div className="flex justify-between items-center py-3 border-b border-white/5 text-sm" data-id="element-105">
          <span className="text-gray-500 font-light" data-id="element-106">Term</span>
          <span className="text-white" data-id="element-107">{data.proposedTerm} Year</span>
        </div>
      </div>

      <div className="space-y-4 text-sm" data-id="element-108">
        <div className="flex items-start gap-4 text-gold font-light" data-id="element-109">
          <Clock className="w-4 h-4 mt-0.5 shrink-0 opacity-80" data-id="element-110" />
          <span data-id="element-111">{data.daysToClose} days to close from start to finish</span>
        </div>
        <div className="flex items-start gap-4 text-gold font-light" data-id="element-112">
          <span className="w-4 text-center shrink-0 opacity-80" data-id="element-113">—</span>
          <span data-id="element-114">No mortgage payment due for 2 months</span>
        </div>
        <div className="flex items-start gap-4 text-gold font-light" data-id="element-115">
          <span className="w-4 text-center shrink-0 opacity-80" data-id="element-116">—</span>
          <span data-id="element-117">Escrow refund check sent to you after closing</span>
        </div>
      </div>
    </motion.div>;
}